import "./App.css";
import React, { useEffect, useRef, useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { Resizable, ResizableBox } from "react-resizable";
import Tabs from "./components/Tabs";
import Outputs from "./components/Outputs";
import { makeStyles } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";

import "codemirror/addon/display/autorefresh";
import "codemirror/addon/comment/comment";
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/javascript-hint";
import "codemirror/addon/selection/active-line";
import "codemirror/addon/display/placeholder";

import "codemirror/keymap/sublime";

import "codemirror/theme/tomorrow-night-bright.css";
import "codemirror/theme/oceanic-next.css";
import "codemirror/theme/monokai.css";
import "codemirror/theme/lucario.css";
import "codemirror/theme/mbo.css";
import executeCode from "./utils/Execute";
import useOutputs from "./hooks/UseOutputs";
import useWindowResizing from "./hooks/UseWindowResizing";
import useFiles from "./hooks/UseFiles";
import useClipboard from "react-use-clipboard";

import worker from "workerize-loader!./worker.js"; // eslint-disable-line import/no-webpack-loader-syntax
import MobileDialog from "./components/MobileDialog";
// Create an instance of your worker
const workerInstance = worker();

const useStyles = makeStyles(() => ({
  icon: {
    color: "grey",
    cursor: "pointer",
    fontSize: 25,
    marginTop: 8,
    marginRight: 12,
  },
}));

let defaultSetting = {
  tabSize: 2,
  theme: "monokai",
  indentUnit: 2,
  language: "js",
};

function App() {
  const { handleSaveFile, addFile, chooseFile, closeFile, files, activeFile } =
    useFiles();

  const { widthLeft, widthRight, onResizeLeft, onResizeRight, heightTop, heightBottom, isMobile, WIDTH, HEIGHT } =
    useWindowResizing();

  const { outputs, add, clear } = useOutputs();

  const [setting, setSetting] = useState(defaultSetting);

  // eslint-disable-next-line no-unused-vars
  const [_, copyClipboard] = useClipboard(files[activeFile].content, {
    successDuration: 1000,
  });

  function copy() {
    copyClipboard();
    console.log("Copied 👍");
  }

  const ref = useRef(null);

  const classes = useStyles();

  function run() {
    clear();
    executeCode(activeFile, files, add);
  }

  function handleSettings(event) {
    event.preventDefault();
    setSetting({ ...setting, [event.target.name]: event.target.value });
  }

  function format() {
    workerInstance.formatCodeApi(files[activeFile].content);
  }

  useEffect(() => {
    workerInstance.addEventListener("message", (message) => {
      message.data.content && handleSaveFile(message.data.content.formatted);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App" style={{ flexDirection: isMobile ? 'column' : 'row'}}>
      <>
      <Resizable
        height={heightTop}
        width={widthLeft}
        onResize={onResizeLeft}
        resizeHandles={["e"]}
        minConstraints={isMobile ? [WIDTH, HEIGHT / 3] : [WIDTH / 3, heightTop]}
        maxConstraints={isMobile ? [WIDTH, (HEIGHT * 3) / 4] : [(WIDTH * 3) / 4, heightTop]}
      >
        <div className="box">
          <div className="files" style={{ width: widthLeft }}>
            <Tabs
              files={files}
              active={activeFile}
              add={addFile}
              choose={chooseFile}
              close={closeFile}
              handleSettings={handleSettings}
              setting={setting}
              run={run}
              copyClipboard={copy}
              format={format}
            />
          </div>
          <CodeMirror
            onChange={(i, _) => handleSaveFile(i.getValue())}
            ref={ref}
            value={files[activeFile].content}
            width={widthLeft}
            height={heightTop}
            options={{
              theme: setting.theme,
              keyMap: "sublime",
              extraKeys: {
                "Ctrl-Space": "autocomplete",
                "Cmd-Space": "autocomplete",
                "Cmd-S": run,
                "Ctrl-S": run,
              },
              mode: "js",
              tabSize: setting.tabSize,
              indentUnit: setting.indentUnit,
              indentWithTabs: true,
              globalVars: true,
              autofocus: true,
              foldGutter: false,
              gutters: [],
              matchBrackets: true,
              autoCloseBrackets: true,
              matchClosing: true,
            }}
            className="code-mirror"
          />
        </div>
      </Resizable>
      <ResizableBox
        className="box box-console"
        width={widthRight}
        height={heightBottom}
        onResize={onResizeRight}
        minConstraints={isMobile ? [WIDTH, HEIGHT/ 4] : [WIDTH / 4, heightBottom]}
        maxConstraints={isMobile ? [WIDTH, (HEIGHT * 3) / 4] : [(WIDTH * 3) / 4, heightBottom]}
        style={{ color: "white" }}
      >
        <>
          <div className="trash">
            <DeleteOutlineOutlinedIcon
              className={classes.icon}
              onClick={clear}
            />
          </div>
          <Outputs outputs={outputs} />
        </>
      </ResizableBox>
      {isMobile && <MobileDialog />}
      </>
    </div>
  );
}

export default App;
